import React from "react"
import {
  Table,
  Tbody,
  Td,
  Tr,
  Skeleton
} from "@chakra-ui/react"
export default function SkeletonTable({ numberOfTd }) {
  return (
    <Table variant="simple" color="gray.500" mb="24px">
      <Tbody>
        {
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, index) => {
            return (
              <Tr key={index}>
                {
                  [1, 2].map((subItem, subIndex) => {
                    if (subItem <= numberOfTd) {
                      return (
                        <Td pl="0px"
                          _first={{ fontWeight: "500", color: "#243e63" }}
                          fontSize={{ sm: "16px" }}
                          justifyContent="space-between"
                          key={subIndex}
                        >
                          <Skeleton isLoaded={false} height={3}>
                          </Skeleton>
                        </Td>
                      )
                    }
                  })
                }
              </Tr>
            )
          })
        }
      </Tbody>
    </Table>
  )
}
